import Vue from 'vue'
import Router from 'vue-router'
import routeNames from './routes'
import store from '@/store'
import { BASE_URL } from '@/config/environment'

Vue.use(Router)
const routes = [
  {
    path: '/login',
    name: routeNames.login.name,
    component: () => import(/* webpackChunkName: 'login' */ '@/views/Login.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/cookies',
    name: routeNames.cookies.name,
    component: () => import(/* webpackChunkName: 'cookies' */ '@/views/Cookies.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: routeNames.main.name,
    component: () => import(/* webpackChunkName: 'main' */ '@/views/Main.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: routeNames.settings.name,
    component: () => import(/* webpackChunkName: 'settings' */ '@/views/Settings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/accounts',
    name: routeNames.accounts.name,
    component: () => import(/* webpackChunkName: 'accounts' */ '@/views/Accounts.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/booking',
    name: routeNames.booking.name,
    component: () => import(/* webpackChunkName: 'booking' */ '@/views/Booking.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/booking/:bookingId/guest/:guestId',
    name: routeNames.guest.name,
    component: () => import(/* webpackChunkName: 'guest' */ '@/views/Guest.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/checkin',
    name: routeNames.checkin.name,
    component: () => import(/* webpackChunkName: 'checkin' */ '@/views/Checkin.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/guest-checkin/:bookingId/:guestId',
    name: routeNames.guestcheckin.name,
    component: () => import(/* webpackChunkName: 'guestCheckin' */ '@/views/GuestCheckin.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/guest-checkin-completed/:bookingId/:guestId',
    name: routeNames.guestcheckincompleted.name,
    component: () => import(/* webpackChunkName: 'guestCheckinCompleted' */ '@/views/GuestCheckinCompleted.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/password',
    name: routeNames.password.name,
    component: () => import(/* webpackChunkName: 'password' */ '@/views/Password.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activity-categories',
    name: routeNames.activity_categories.name,
    component: () => import(/* webpackChunkName: 'activity-categories' */ '@/views/activities/ActivityCategories.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activity-categories/:categoryId',
    name: routeNames.activities.name,
    component: () => import(/* webpackChunkName: 'activities' */ '@/views/activities/Activities.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activities/:activityId',
    name: routeNames.activity_details.name,
    component: () => import(/* webpackChunkName: 'activity-details' */ '@/views/activities/ActivityDetails.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activities/:activityId/reservation/complete',
    name: routeNames.reservationComplete.name,
    component: () => import(/* webpackChunkName: 'reservation-complete' */ '@/views/reservation/Complete.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activities/:activityId/reservation/error',
    name: routeNames.reservationError.name,
    component: () => import(/* webpackChunkName: 'reservation-error' */ '@/views/reservation/Error.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activities/:activityId/reservation/summary',
    name: routeNames.reservationSummary.name,
    component: () => import(/* webpackChunkName: 'reservation-summary' */ '@/views/reservation/Summary.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activities/:activityId/reservation',
    name: routeNames.reservationCommonData.name,
    component: () => import(/* webpackChunkName: 'reservation-common-data' */ '@/views/reservation/CommonData.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activity-reservations',
    name: routeNames.activity_reservations.name,
    component: () => import(/* webpackChunkName: 'activity-reservations' */ '@/views/reservation/ActivityReservations.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activities/:activityId/reservation/catalog',
    name: routeNames.reservationCatalog.name,
    component: () => import(/* webpackChunkName: 'reservation-catalog' */ '@/views/reservation/Catalog.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activities/:activityId/reservation/catalog/product/:productId',
    name: routeNames.catalogProductSelection.name,
    component: () => import(/* webpackChunkName: 'product-selection' */ '@/views/reservation/ProductSelection.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activities/:activityId/reservation/catalog/category/:catalogCategoryId',
    name: routeNames.catalogCategorySelection.name,
    component: () => import(/* webpackChunkName: 'category-selection' */ '@/views/reservation/CategorySelection.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '*',
    redirect: { name: routeNames.main.name },
  },
]

const router = new Router({
  mode: 'history',
  base: BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.query.inactivity_timeout !== undefined) {
    store.state.state.inactivityTimeout = parseInt(to.query.inactivity_timeout)
  }
  if (to.query['x-api-key'] !== undefined) {
    store.commit('auth/replaceAuthToken', to.query['x-api-key'])
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/authStatus']) {
      store.state.state.firstLoad = true
      next({ name: routeNames.login.name })
    } else {
      if (!from.name || from.name === routeNames.login.name) {
        await store.dispatch('me/getSettings').catch(() => {})
      }
      store.state.state.firstLoad = true
      next()
    }
  } else {
    if (store.getters['auth/authStatus']) {
      if (!from.name || from.name === routeNames.login.name) {
        await store.dispatch('me/getSettings').catch(() => {})
      }
      store.state.state.firstLoad = true
      next({ name: routeNames.main.name })
    } else {
      next()
    }
    store.state.state.firstLoad = true
  }
})

export default router
